import React from "react";
import { GenericTableColumn } from "@ui-components/Table/GenericTable";

/**
 * Interfaz de cada row devuelta por 
 * GET /v1/ctxr/-1/listUnlicensed?tenantId=1
 */
export interface UnlicensedInstance {
    id: string;
    name: string;
    description: string;
    lastupdate: string;   // p.ej "2024-11-26T22:05:16.000Z"
    Suscription: string;  // p.ej "Internal Telecom"
    activated: string;    // p.ej "2024-11-05T17:37:52.000Z"
    deactivate: string;   // p.ej "2025-03-02T04:09:37.000Z"
}

/** 
 * Función auxiliar para formatear fecha a DD-MM-YYYY 
 */
function formatDate(isoDate: string): string {
    if (!isoDate) return "";
    const dateObj = new Date(isoDate);
    const dd = String(dateObj.getDate()).padStart(2, "0");
    const mm = String(dateObj.getMonth() + 1).padStart(2, "0");
    const yyyy = dateObj.getFullYear();
    return `${dd}-${mm}-${yyyy}`;
}

/**
 * Columnas para la tabla “Unlicensed Instances”:
 */
export const columns: GenericTableColumn<UnlicensedInstance>[] = [
    {
        header: "Name",
        accessor: "name",
    },
    {
        header: "Description",
        accessor: "description",
    },
    {
        header: "ID",
        accessor: "id",
    },
    {
        header: "Deactivate",
        accessor: "deactivate",
        renderCell: (row) => {
            // Aquí transformamos "2025-03-02T04:09:37.000Z" => "02-03-2025"
            return formatDate(row.deactivate);
        },
    },
    {
        header: "Actions",
        // Este se sobreescribe en tu UnlicensedPage con el botón de la papelera
        accessor: "id",
        renderCell: () => <div>Will be overridden in UnlicensedPage</div>,
    },
];
